import React from 'react';
import './Roadmap.css';
import phase1Image from '../assets/2025.png';  // Add your images
import phase2Image from '../assets/2026.png';
import phase3Image from '../assets/2027.png';
import phase4Image from '../assets/2028.png';

function Roadmap() {
  return (
    <section className="roadmap">
      <h2 className="roadmap-title">Community Roadmap</h2>
      <div className="roadmap-container">
        <div className="roadmap-item">
          <div className="roadmap-image-container">
            <img src={phase1Image} alt="Phase 1" className="roadmap-image" />
          </div>
          <h3>Phase 1</h3>
          <ul>
            <li>
              Launch on <span style={{color: "green", hover: "red", cursor: "pointer"}} href="https://pump.fun">pump.fun</span>
            </li>
            <li>Community Building</li>
            <li>project audit</li>
            <li>Marketing Campaign</li>
            <li>Exchange Listings</li>
          </ul>
        </div>

        <div className="roadmap-item">
          <div className="roadmap-image-container">
            <img src={phase2Image} alt="Phase 2" className="roadmap-image" />
          </div>
          <h3>Phase 2</h3>
          <ul>
            <li>More Exchange Applications</li>
            <li>Partnership Development</li>
            <li>$Potus NFTs</li>
            <li>Community Events</li>
            <li>$Potus Merch</li>
          </ul>
        </div>

        <div className="roadmap-item">
          <div className="roadmap-image-container">
            <img src={phase3Image} alt="Phase 3" className="roadmap-image" />
          </div>
          <h3>Phase 3</h3>
          <ul>
            <li>Global Expansion</li>
            <li>Major Partnerships and Exchanges Recognition</li>
            <li>Governance Launch</li>
            <li>Ecosystem Growth</li>
          </ul>
        </div>

        <div className="roadmap-item">
          <div className="roadmap-image-container">
            <img src={phase4Image} alt="Phase 4" className="roadmap-image" />
          </div>
          <h3>Phase 4</h3>
          <ul>
            <li>$POTUS HANDOVER</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Roadmap; 